export {
  InfoList,
  type InfoListProps,
  type InfoListItem,
} from '../../compositions/shared/InfoList';
